export default __webpack_public_path__ + "static/media/avatar_20.cdb2ca9d.svg";